import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { InventoryCountTagDet } from '../model/InventoryCountTagDet';

@Injectable()
export class InventoryCountTagDetFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAllByInvCountId(invCountId: number): Observable<RequestResponse<InventoryCountTagDet[]>> {
        return this._httpClient.get<RequestResponse<InventoryCountTagDet[]>>(this._urlBase + 'api/InventoryCountTagDet/' + invCountId);
    }

}
